
import { useSelector } from 'react-redux';


export const useUserPermissionData = (permcode) => {
    const userData = useSelector(state => state.authReducer);
    if (!userData || !userData.user || !userData.user.data || !userData.user.data.role || !userData.user.data.role.permissions)
        return false;

    const permissionArr = userData.user.data.role.permissions;
    return permissionArr.some(permission => permission.permission_code === permcode);
}